import { AbstractModelSchema } from './abstract_model_schema.js';
import { biteSettingsSchema } from './settings_bite_schema.js';
import { commonSettingsSchema } from './settings_common_schema.js';
import { flashSettingsSchema } from './settings_flash_schema.js';
import { kioskSettingsSchema } from './settings_kiosk_schema.js';
import { menuAppearanceSettingsSchema } from './settings_menu_appearance_schema.js';
import { receiptSettingsSchema } from './settings_receipt_schema.js';
import { recommendationSettingsSchema } from './settings_recommendations_schema.js';
/**
 * We just need this to be able to use in for request schemas
 */
export const settingsOverridableFields = {
    displayName: 'Settings Overridable Fields',
    type: 'object',
    fields: {
        // Location Model Settings
        // BITE SETTINGS
        ...biteSettingsSchema,
        // BITE LIFT SETTINGS
        ...recommendationSettingsSchema,
        // FLASH SETTINGS
        ...flashSettingsSchema,
        // KIOSK SETTINGS
        ...kioskSettingsSchema,
        ...receiptSettingsSchema,
        // COMMON SETTINGS
        ...commonSettingsSchema,
        // MENU.APPEARANCE MODEL SETTINGS
        // APPEARANCE
        ...menuAppearanceSettingsSchema,
    },
};
export const settingsSchema = {
    displayName: 'Settings',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        scope: {
            type: 'keyString',
            required: true,
            isHidden: true,
            isReadOnly: true,
            tabId: 'bite-settings-v2',
        },
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
            tabId: 'bite-settings-v2',
        },
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
            tabId: 'bite-settings-v2',
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
            tabId: 'bite-settings-v2',
        },
        overrideSet: {
            type: 'array',
            elementType: 'keyString', // Key of Settings.Data
            isHidden: true,
            isReadOnly: true,
            tabId: 'bite-settings-v2',
        },
        ...settingsOverridableFields.fields,
    },
};
//# sourceMappingURL=settings_schema.js.map